import { useTranslation } from 'react-i18next';

import { StatisticCardRepostProps } from './types';

import DoubleSection from '../DoubleSection';

import { formatNumber } from 'features/helpers/formatNumber';

import { roundToNearestAfterDecimal } from 'features/helpers/helpers';
import { generalSummaryRepost } from 'features/helpers/statistics/generalSummaryRepost';

export const StatisticCardRepost = ({ statistics }: StatisticCardRepostProps) => {
  const { t } = useTranslation('stats-for-client');

  const summary = generalSummaryRepost(statistics);

  const totalTransitions = statistics.orders.reduce((acc, order) => acc + order.transitionsCount, 0);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-3">
      <DoubleSection
        bottomTitle={'подписчиков'}
        bottomValue={formatNumber(summary.totalParticipants || 0)}
        topValue={formatNumber(roundToNearestAfterDecimal(statistics.channels.length || 0))}
        topTitle={'Каналов'}
        tooltip="общее количество каналов и подписчиков"
      />
      <DoubleSection
        bottomTitle={'просмотров'}
        bottomValue={formatNumber(summary.totalViews || 0)}
        topValue={`${formatNumber(roundToNearestAfterDecimal(summary.repostViewPercentage || 0))}%`}
        topTitle={t('percentage_views')}
        tooltip="процент подписчиков, которые посмотрили пост и всего просмотров"
      />
      <DoubleSection
        topTitle={'CPM'}
        topValue={formatNumber(summary.cpmViews || 0)}
        bottomValue={`${formatNumber(roundToNearestAfterDecimal(summary.totalViews / summary.totalParticipants || 0))}`}
        bottomTitle={'в среднем просмотров'}
        tooltip="стоимость 1000 показов"
      />
      <DoubleSection
        topTitle={'постов'}
        topValue={formatNumber(summary.totalReposts || 0)}
        bottomValue={`${totalTransitions}`}
        bottomTitle={'всего переходов'}
      />
    </div>
  );
};
